export enum SandboxMessageToHostToasterStatus {
  success = 'SUCCESS',
  error = 'ERROR',
  warning = 'WARNING',
  info = 'INFO',
}
